import MaterialAccordionDetails, {
    AccordionDetailsProps,
} from '@mui/material/AccordionDetails';

export function AccordionDetails(props: AccordionDetailsProps) {
    return (
        <MaterialAccordionDetails
            data-testid={'AccordionDetails-container'}
            {...props}
        />
    );
}

export default AccordionDetails;
